// Device Share storage. Namespaced by (organization_id, user_identity_id) so a
// user that signs in to two different companies on the same browser keeps two
// separate devices.
//
// We store the share as base64 — never the cleartext private key, never any
// other component of the key material. Only this module touches localStorage.

const NAMESPACE = 'sigil.device-share';

function key(orgID: string, userIdentityID: string, curve = 'secp256k1'): string {
  return `${NAMESPACE}:${orgID}:${userIdentityID}:${curve}`;
}

function legacyKey(orgID: string, userIdentityID: string): string {
  return `${NAMESPACE}:${orgID}:${userIdentityID}`;
}

export function readDeviceShare(orgID: string, userIdentityID: string, curve = 'secp256k1'): string | null {
  const val = window.localStorage.getItem(key(orgID, userIdentityID, curve));
  if (val) return val;
  // Backward compat: existing secp256k1 shares used the old key format.
  if (curve === 'secp256k1') {
    return window.localStorage.getItem(legacyKey(orgID, userIdentityID));
  }
  return null;
}

export function writeDeviceShare(orgID: string, userIdentityID: string, shareB64: string, curve = 'secp256k1'): void {
  window.localStorage.setItem(key(orgID, userIdentityID, curve), shareB64);
}

export function clearDeviceShare(orgID: string, userIdentityID: string, curve = 'secp256k1'): void {
  window.localStorage.removeItem(key(orgID, userIdentityID, curve));
  if (curve === 'secp256k1') {
    window.localStorage.removeItem(legacyKey(orgID, userIdentityID));
  }
}

const SESSION_NAMESPACE = 'sigil.session';

export function readSessionToken(orgID: string): string | null {
  return window.sessionStorage.getItem(`${SESSION_NAMESPACE}:${orgID}`);
}

export function writeSessionToken(orgID: string, token: string): void {
  window.sessionStorage.setItem(`${SESSION_NAMESPACE}:${orgID}`, token);
}

export function clearSessionToken(orgID: string): void {
  window.sessionStorage.removeItem(`${SESSION_NAMESPACE}:${orgID}`);
}
